import { render, staticRenderFns } from "./rlbadd.vue?vue&type=template&id=2a704f02&scoped=true&"
import script from "./rlbadd.vue?vue&type=script&lang=js&"
export * from "./rlbadd.vue?vue&type=script&lang=js&"
import style0 from "./rlbadd.vue?vue&type=style&index=0&id=2a704f02&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a704f02",
  null
  
)

export default component.exports